import React, { useEffect, useState } from 'react'
import { Container, Form, Tabs, Tab, Button, Row, Col } from 'react-bootstrap'
import { CATEGORIES_COLLECTION, GAMES_COLLECTION, serverTimestamp } from '../../firebase'
import { v4 as uuidv4 } from 'uuid'
import { useHistory } from 'react-router'
import urlSlug from 'url-slug'

const INITIAL_STATE = {
    _id: '',
    buy_one: '',
    buy_two: '',
    buy_three: '',
    category: [],
    date: serverTimestamp.now(),
    discount: '',
    iframe: '',
    image: '',
    poster: '',
    rating: '',
    release: '',
    rent_one: '',
    rent_two: '',
    slider: false,
    url: '',
    description_en: '',
    description_sr: '',
    details_en: '',
    details_sr: '',
    title_en: '',
    title_sr: '',
    specifications_and_requirements_en: '',
    specifications_and_requirements_sr: '',
    video: ''
}

const AddGame = () => {

    const history = useHistory();

    const [add, setAdd] = useState(INITIAL_STATE)

    const [categories, setCategories] = useState([]);

    const handleAdd = async (e) => {

        e.preventDefault();

        const _id = uuidv4();

        await GAMES_COLLECTION.doc(_id).set({
            _id: _id,
            buy_one: add.buy_one,
            buy_two: add.buy_two,
            buy_three: add.buy_three,
            category: add.category,
            date: add.date,
            discount: add.discount,
            iframe: add.iframe,
            image: add.image,
            poster: add.poster,
            rating: add.rating,
            release: serverTimestamp.fromDate(new Date(add.release)),
            rent_one: add.rent_one,
            rent_two: add.rent_two,
            slider: 'true' === add.slider,
            url: urlSlug(add.title_sr),
            description_en: add.description_en,
            description_sr: add.description_sr,
            details_en: add.details_en,
            details_sr: add.details_sr,
            title_en: add.title_en,
            title_sr: add.title_sr,
            specifications_and_requirements_en: add.specifications_and_requirements_en,
            specifications_and_requirements_sr: add.specifications_and_requirements_sr,
            video: add.video
        })
            .then(() => {
                alert("Uspješno dodano 👍")
                history.push('/')
            })
            .catch((error) => {
                alert(error.message)
            })
    }

    useEffect(() => {

        const getCategories = async () => {
            const snapshot = await CATEGORIES_COLLECTION.get();
            const items = []
            snapshot.forEach(doc => {
                items.push(doc.data());
            })
            setCategories(items)
        }

        getCategories()

    }, []);

    return (
        <>
            <div>
                <Container>
                    <Tabs defaultActiveKey="add-game" className="mb-3" transition={false}>
                        <Tab eventKey="preview-game" title={<div onClick={() => history.push('/')}>Pregled igara</div>} />
                        <Tab eventKey="add-game" title="Dodaj">
                            <Form onSubmit={handleAdd}>
                                <Row>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prodaja (Offline profil)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Unesite - Prodaja (Offline profil)"
                                                value={add.buy_one}
                                                onChange={(e) => { setAdd({ ...add, buy_one: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prodaja (Primarni profil)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Unesite - Prodaja (Primarni profil)"
                                                value={add.buy_two}
                                                onChange={(e) => { setAdd({ ...add, buy_two: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Prodaja (Sekundarni profil)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Unesite - Prodaja (Sekundarni profil)"
                                                value={add.buy_three}
                                                onChange={(e) => { setAdd({ ...add, buy_three: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Kategorija</Form.Label>
                                            <Form.Control
                                                as="select"
                                                multiple={true}
                                                value={add.category}
                                                onChange={(e) => { setAdd({ ...add, category: [...e.target.selectedOptions].map(o => o.value) }) }}
                                                required
                                            >
                                                <option value="" disabled>Odaberite</option>
                                                {
                                                    categories.map((item) =>
                                                        <option key={item._id} value={item.category}>
                                                            {item.title_sr}
                                                        </option>)
                                                }
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Popust</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Unesite - Popust"
                                                value={add.discount}
                                                onChange={(e) => { setAdd({ ...add, discount: e.target.value }) }}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Media</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Media"
                                                value={add.iframe}
                                                onChange={(e) => { setAdd({ ...add, iframe: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Slika</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Slika"
                                                value={add.image}
                                                onChange={(e) => { setAdd({ ...add, image: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Poster (video)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Poster (video)"
                                                value={add.poster}
                                                onChange={(e) => { setAdd({ ...add, poster: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Ocjena</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Unesite - Ocjena"
                                                value={add.rating}
                                                onChange={(e) => { setAdd({ ...add, rating: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Objavljeno</Form.Label>
                                            <Form.Control
                                                type="date"
                                                placeholder="Unesite - Objavljeno"
                                                value={add.release}
                                                onChange={(e) => { setAdd({ ...add, release: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Iznajmljivanje (8 dana)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Unesite - Iznajmljivanje (8 dana)"
                                                value={add.rent_one}
                                                onChange={(e) => { setAdd({ ...add, rent_one: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Iznajmljivanje (15 dana)</Form.Label>
                                            <Form.Control
                                                type="number"
                                                placeholder="Unesite - Iznajmljivanje (8 dana)"
                                                value={add.rent_two}
                                                onChange={(e) => { setAdd({ ...add, rent_two: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Istaknuto (slider)</Form.Label>
                                            <Form.Control
                                                as="select"
                                                value={add.slider}
                                                onChange={(e) => { setAdd({ ...add, slider: e.target.value }) }}
                                                required
                                            >
                                                <option value="" disabled>Odaberite</option>
                                                <option value='false'>Ne</option>
                                                <option value='true'>Da</option>
                                            </Form.Control>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Opis (EN)</Form.Label>
                                            <Form.Control
                                                rows={5}
                                                as="textarea"
                                                placeholder="Unesite - Opis (EN)"
                                                value={add.description_en}
                                                onChange={(e) => { setAdd({ ...add, description_en: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Opis (SR)</Form.Label>
                                            <Form.Control
                                                rows={5}
                                                as="textarea"
                                                placeholder="Unesite - Opis (SR)"
                                                value={add.description_sr}
                                                onChange={(e) => { setAdd({ ...add, description_sr: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Detalji (EN)</Form.Label>
                                            <Form.Control
                                                rows={5}
                                                as="textarea"
                                                placeholder="Unesite - Detalji (EN)"
                                                value={add.details_en}
                                                onChange={(e) => { setAdd({ ...add, details_en: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Detalji (SR)</Form.Label>
                                            <Form.Control
                                                rows={5}
                                                as="textarea"
                                                placeholder="Unesite - Detalji (SR)"
                                                value={add.details_sr}
                                                onChange={(e) => { setAdd({ ...add, details_sr: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Naslov (EN)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Naslov (EN)"
                                                value={add.title_en}
                                                onChange={(e) => { setAdd({ ...add, title_en: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Naslov (SR)</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Naslov (SR)"
                                                value={add.title_sr}
                                                onChange={(e) => { setAdd({ ...add, title_sr: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Specifikacije i zahtjevi (EN)</Form.Label>
                                            <Form.Control
                                                rows={5}
                                                as="textarea"
                                                placeholder="Unesite - Specifikacije i zahtjevi (EN)"
                                                value={add.specifications_and_requirements_en}
                                                onChange={(e) => { setAdd({ ...add, specifications_and_requirements_en: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col lg={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Specifikacije i zahtjevi (SR)</Form.Label>
                                            <Form.Control
                                                rows={5}
                                                as="textarea"
                                                placeholder="Unesite - Specifikacije i zahtjevi (SR)"
                                                value={add.specifications_and_requirements_sr}
                                                onChange={(e) => { setAdd({ ...add, specifications_and_requirements_sr: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Video</Form.Label>
                                            <Form.Control
                                                type="text"
                                                placeholder="Unesite - Video"
                                                value={add.video}
                                                onChange={(e) => { setAdd({ ...add, video: e.target.value }) }}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <Button variant="primary" type="submit">
                                            Dodaj
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Tab>
                        <Tab eventKey="edit-game" title='Uredi' disabled />
                        <Tab eventKey="delete-game" title='Obriši' disabled />
                    </Tabs>
                </Container>
            </div>
        </>
    )
}

export default AddGame
